import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import sosLogServices from '../services/sos-log.service';

export const useUpdateSosLogStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sosLogServices.updateSosLogStatus,
    onSuccess: (data) => {
      toast.success(data.message || 'SOS status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['sos-logs'] });
      queryClient.invalidateQueries({ queryKey: ['sos-log'] });
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to update SOS status');
    },
  });
};
